/*
export default {
  namespaced: true,
  state: {
    themes: {
      black: { name: 'black', className: 'theme_black' },
      white: { name: 'white', className: 'theme_white' },
    },
    curTheme: 'black',
  },
  getters: {
    getThemes(state) {
      return state.themes;
    },
    getCurTheme(state) {
      return state.curTheme;
    },
  },
  mutations: {
    setCurTheme(state, newTheme) {
      state.curTheme = newTheme;
    },
  },
};
*/

/* eslint-disable no-param-reassign */
const stateData = {
  curTheme: '',
  defaultTheme: 'theme-b',
};

const getters = {
  curTheme(st) {
    return st.curTheme;
  },
};

const mutations = {
  setCurTheme(st, newTheme) {
    localStorage.setItem('curTheme', newTheme);
    if (st.curTheme) {
      document.body.classList.remove(st.curTheme);
    }
    document.body.classList.add(newTheme);
    st.curTheme = newTheme;
  },
};

const actions = {
  setStoredTheme({ commit, state }) {
    let theme = localStorage.getItem('curTheme');
    if (!theme) {
      theme = state.defaultTheme;
    }
    commit('setCurTheme', theme);
  },
};

export default {
  namespaced: true,
  state: stateData,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/theme.js